// IconMap.tsx
import React from 'react';
import { 
  Add, 
  Edit, 
  EditNote, 
  Preview, 
  Clear, 
  Delete, 
  Print, 
  Download, 
  Upload, 
  ChangeCircle, 
  ReplayCircleFilled, 
  KeyboardArrowUp, 
  KeyboardArrowDown,
  CopyAll 
} from '@mui/icons-material';

const IconMap: { [key: string]: React.ElementType } = {
  Add,
  Edit,
  EditNote,
  Preview,
  Clear,
  Delete,
  Print,
  Download,
  Upload,
  ChangeCircle,
  ReplayCircleFilled,
  KeyboardArrowUp,
  KeyboardArrowDown,
  CopyAll
};

export default IconMap;
